import { Stack, Group, Skeleton } from '@mantine/core';

/** Jadval yuklanayotganda skeleton qatorlar (spinner o'rniga — silliqroq UX). */
export function TableSkeleton({ rows = 6, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <Stack gap="sm" p="md">
      {Array.from({ length: rows }).map((_, r) => (
        <Group key={r} justify="space-between" wrap="nowrap">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} height={14} radius="sm" width={c === 0 ? '30%' : `${Math.max(12, 20 - c * 3)}%`} />
          ))}
        </Group>
      ))}
    </Stack>
  );
}

/** Kartalar to'ri uchun skeleton. */
export function CardsSkeleton({ count = 6, height = 92 }: { count?: number; height?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} height={height} radius="lg" />
      ))}
    </>
  );
}
